export enum FolderType {
  CLINICAL = 'CLINICAL',
  IMAGING = 'IMAGING',
  LCA = 'LCA',
  KFP = 'KFP',
  TCS = 'TCS',
}
